import React from 'react';
import '../myutils';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader'
import { translate } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    position: 'sticky', 
    top: '0',
    background: '#FAFAFA',
    zIndex: '1000'
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const classes = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

const style = { flex: 1 , maxHeight: 350, overflow: 'auto'};

export default translate(({ transactions = [], translate }) => (
    <div>
    <CardHeader title={translate('pos.dashboard.transaction_list')} />
    <Card style={style}>
    <Table className={classes.table}>
        <TableHead >
          <TableRow>
            <CustomTableCell>{translate('trans.transactionTime')}</CustomTableCell>
            <CustomTableCell numeric>{translate('trans.amount')}</CustomTableCell>
            <CustomTableCell >{translate('trans.description')}</CustomTableCell>
            <CustomTableCell >{translate('trans.who')}</CustomTableCell>
            <CustomTableCell numeric>{translate('trans.newBalance')}</CustomTableCell>
            <CustomTableCell >{translate('trans.expireDate')}</CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.map(row => {
            return (
              <TableRow className={classes.row} key={row.id}>
                <CustomTableCell component="th" scope="row">
                  {row.transactionTime}
                </CustomTableCell>
                <CustomTableCell numeric>{row.amount}</CustomTableCell>
                <CustomTableCell >{row.description}</CustomTableCell>
                <CustomTableCell >{row.who}</CustomTableCell>
                <CustomTableCell numeric>{Math.round(row.newBalance,2)}</CustomTableCell>
                <CustomTableCell >{row.expireDate}</CustomTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    
        {/* <List>
            {transactions.map(record =>
                <ListItem
                    key={record.id}
                >
                <ListItemText
                    primary={record.description}
                    secondary={record.transactionTime}
                  />
                {record.amount}
                </ListItem>
            )}
        </List> */}
    </Card>
    </div>
));
